import React, { useState, useRef } from "react";
import MyStudentLayout from "../../../layouts/Student/MyStudentLayout";

import "../../../assets/css/student/ReportIssue.css";

// ─── SVG ICON SET ────────────────────────────────────────────────────────────

const Icons = {
  Open: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="10" />
      <line x1="12" y1="8" x2="12" y2="12" />
      <line x1="12" y1="16" x2="12.01" y2="16" />
    </svg>
  ),
  InProgress: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="23 4 23 10 17 10" />
      <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10" />
    </svg>
  ),
  Resolved: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
      <polyline points="22 4 12 14.01 9 11.01" />
    </svg>
  ),
  Clock: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="10" />
      <polyline points="12 6 12 12 16 14" />
    </svg>
  ),
  Mentor: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
      <circle cx="12" cy="7" r="4" />
    </svg>
  ),
  Course: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
      <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
    </svg>
  ),
  Assignment: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      <polyline points="14 2 14 8 20 8" />
      <line x1="16" y1="13" x2="8" y2="13" />
      <line x1="16" y1="17" x2="8" y2="17" />
      <polyline points="10 9 9 9 8 9" />
    </svg>
  ),
  Payment: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="1" y="4" width="22" height="16" rx="2" ry="2" />
      <line x1="1" y1="10" x2="23" y2="10" />
    </svg>
  ),
  Bug: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M8 2l1.88 1.88" />
      <path d="M14.12 3.88L16 2" />
      <path d="M9 7.13v-1a3.003 3.003 0 1 1 6 0v1" />
      <path d="M12 20c-3.3 0-6-2.7-6-6v-3a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v3c0 3.3-2.7 6-6 6z" />
      <path d="M12 20v-9" />
      <path d="M6.53 9C4.6 8.8 3 7.1 3 5" />
      <path d="M6 13H2" />
      <path d="M3 21c0-2.1 1.7-3.9 3.8-4" />
      <path d="M20.97 5c0 2.1-1.6 3.8-3.5 4" />
      <path d="M22 13h-4" />
      <path d="M17.2 17c2.1.1 3.8 1.9 3.8 4" />
    </svg>
  ),
  Other: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="12" r="1" />
      <circle cx="19" cy="12" r="1" />
      <circle cx="5" cy="12" r="1" />
    </svg>
  ),
  Attach: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" />
    </svg>
  ),
  Send: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <line x1="22" y1="2" x2="11" y2="13" />
      <polygon points="22 2 15 22 11 13 2 9 22 2" />
    </svg>
  ),
  Close: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </svg>
  ),
  ChevronRight: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="9 18 15 12 9 6" />
    </svg>
  ),
  ChevronLeft: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="15 18 9 12 15 6" />
    </svg>
  ),
  Check: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="20 6 9 17 4 12" />
    </svg>
  ),
  Flag: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z" />
      <line x1="4" y1="22" x2="4" y2="15" />
    </svg>
  ),
  Eye: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  ),
  Comment: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
    </svg>
  ),
  Upload: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="16 16 12 12 8 16" />
      <line x1="12" y1="12" x2="12" y2="21" />
      <path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3" />
    </svg>
  ),
  Link: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
      <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
    </svg>
  ),
  Agent: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
    </svg>
  ),
  Reopen: () => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M1 4v6h6" />
      <path d="M3.51 15a9 9 0 1 0 .49-4.2" />
    </svg>
  ),
};

// ─── DATA ────────────────────────────────────────────────────────────────────

const CATEGORIES = [
  { id: "mentor", label: "Mentor Issue", Icon: Icons.Mentor },
  { id: "course", label: "Course Issue", Icon: Icons.Course },
  { id: "assignment", label: "Assignment Issue", Icon: Icons.Assignment },
  { id: "payment", label: "Payment Issue", Icon: Icons.Payment },
  { id: "bug", label: "Platform Bug", Icon: Icons.Bug },
  { id: "other", label: "Other", Icon: Icons.Other },
];

const ISSUE_TYPES = {
  mentor: [
    "No response from mentor",
    "Rude or unprofessional behavior",
    "Wrong or misleading guidance",
    "Session not conducted",
    "Harassment or misconduct",
  ],
  course: [
    "Missing course content",
    "Incorrect material",
    "Confusing explanation",
    "Outdated information",
    "Technical playback issues",
  ],
  assignment: [
    "Assignment not graded",
    "Incorrect grade given",
    "Submission not received",
    "Unclear instructions",
    "Deadline discrepancy",
  ],
  payment: [
    "Failed transaction",
    "Duplicate charge",
    "Refund request",
    "Incorrect amount billed",
    "Subscription not activated",
  ],
  bug: [
    "Page not loading",
    "Feature not working",
    "Data loss or corruption",
    "Login or access issue",
    "Notification failure",
  ],
  other: [
    "Account issue",
    "Feedback or suggestion",
    "General inquiry",
    "Policy question",
    "Other concern",
  ],
};

const PRIORITIES = [
  {
    id: "low",
    label: "Low",
    color: "#6b7280",
    desc: "Non-urgent, can wait a few days",
  },
  {
    id: "medium",
    label: "Medium",
    color: "#f59e0b",
    desc: "Should be resolved within 48 hours",
  },
  {
    id: "high",
    label: "High",
    color: "#ef4444",
    desc: "Needs attention within 24 hours",
  },
  {
    id: "urgent",
    label: "Urgent",
    color: "#7c3aed",
    desc: "Critical issue requiring immediate action",
  },
];

const MOCK_REPORTS = [
  {
    id: "RPT-1042",
    category: "mentor",
    categoryLabel: "Mentor Issue",
    issueType: "No response from mentor",
    subject: "Mentor has not responded to messages for 5 days",
    description:
      "I have been trying to reach my assigned mentor Dr. Ahmed for the past 5 days regarding my final project submission. Despite sending multiple messages through the platform, I have not received any response. The submission deadline is approaching and I urgently need guidance.",
    status: "in_progress",
    priority: "high",
    createdAt: "2025-01-08T10:30:00Z",
    updatedAt: "2025-01-09T14:00:00Z",
    assignedTo: "Support Team",
    thread: [
      {
        id: 1,
        sender: "You",
        role: "student",
        message:
          "I have been trying to reach my mentor for 5 days. Please help.",
        time: "Jan 8, 10:30 AM",
      },
      {
        id: 2,
        sender: "Support Agent",
        role: "support",
        message:
          "Thank you for reaching out. We have escalated this to the mentor coordination team. You should receive a response within 24 hours.",
        time: "Jan 8, 2:15 PM",
      },
      {
        id: 3,
        sender: "You",
        role: "student",
        message:
          "It has been another day and still no response from the mentor.",
        time: "Jan 9, 9:00 AM",
      },
      {
        id: 4,
        sender: "Support Agent",
        role: "support",
        message:
          "We sincerely apologize for the delay. We have contacted the mentor directly and they will reach out within 4 hours. We are also assigning a backup mentor as a precaution.",
        time: "Jan 9, 2:00 PM",
      },
    ],
    timeline: [
      {
        stage: "Submitted",
        time: "Jan 8, 10:30 AM",
        agent: "System",
        note: "Report created and queued for review",
        done: true,
      },
      {
        stage: "Reviewed",
        time: "Jan 8, 11:00 AM",
        agent: "System Auto-Triage",
        note: "Classified as high priority mentor issue",
        done: true,
      },
      {
        stage: "Assigned",
        time: "Jan 8, 2:00 PM",
        agent: "Support Team",
        note: "Assigned to Mentor Relations team",
        done: true,
      },
      {
        stage: "In Progress",
        time: "Jan 9, 2:00 PM",
        agent: "Mentor Relations",
        note: "Direct contact made with mentor",
        done: true,
      },
      { stage: "Resolved", time: null, agent: null, note: null, done: false },
    ],
  },
  {
    id: "RPT-1038",
    category: "payment",
    categoryLabel: "Payment Issue",
    issueType: "Duplicate charge",
    subject: "Charged twice for January subscription",
    description:
      "I was charged twice for my January subscription. The amount of PKR 2,500 was debited from my account on January 1st and again on January 3rd.",
    status: "resolved",
    priority: "high",
    createdAt: "2025-01-04T08:00:00Z",
    updatedAt: "2025-01-06T16:00:00Z",
    assignedTo: "Billing Team",
    thread: [
      {
        id: 1,
        sender: "You",
        role: "student",
        message:
          "I was charged twice. Please refund the duplicate charge immediately.",
        time: "Jan 4, 8:00 AM",
      },
      {
        id: 2,
        sender: "Billing Agent",
        role: "support",
        message:
          "We have confirmed the duplicate charge. A refund of PKR 2,500 has been initiated and will reflect in 3-5 business days.",
        time: "Jan 5, 10:00 AM",
      },
    ],
    timeline: [
      {
        stage: "Submitted",
        time: "Jan 4, 8:00 AM",
        agent: "System",
        note: "Payment dispute report created",
        done: true,
      },
      {
        stage: "Reviewed",
        time: "Jan 4, 9:00 AM",
        agent: "Billing System",
        note: "Duplicate charge verified in payment logs",
        done: true,
      },
      {
        stage: "Assigned",
        time: "Jan 4, 9:30 AM",
        agent: "Billing Team",
        note: "Assigned to billing specialist",
        done: true,
      },
      {
        stage: "In Progress",
        time: "Jan 5, 10:00 AM",
        agent: "Billing Team",
        note: "Refund initiated",
        done: true,
      },
      {
        stage: "Resolved",
        time: "Jan 6, 4:00 PM",
        agent: "Billing Team",
        note: "Refund confirmed and case closed",
        done: true,
      },
    ],
  },
  {
    id: "RPT-1031",
    category: "course",
    categoryLabel: "Course Issue",
    issueType: "Missing course content",
    subject: "Module 4 videos are missing from Web Dev course",
    description:
      "Module 4 of the Full Stack Web Development course appears to be incomplete. Videos 4.3 through 4.7 are showing as unavailable.",
    status: "open",
    priority: "medium",
    createdAt: "2025-01-10T15:00:00Z",
    updatedAt: "2025-01-10T15:00:00Z",
    assignedTo: null,
    thread: [
      {
        id: 1,
        sender: "You",
        role: "student",
        message: "Module 4 videos are missing. Cannot continue the course.",
        time: "Jan 10, 3:00 PM",
      },
    ],
    timeline: [
      {
        stage: "Submitted",
        time: "Jan 10, 3:00 PM",
        agent: "System",
        note: "Report submitted and pending review",
        done: true,
      },
      { stage: "Reviewed", time: null, agent: null, note: null, done: false },
      { stage: "Assigned", time: null, agent: null, note: null, done: false },
      {
        stage: "In Progress",
        time: null,
        agent: null,
        note: null,
        done: false,
      },
      { stage: "Resolved", time: null, agent: null, note: null, done: false },
    ],
  },
];

// ─── KPI WIDGET ──────────────────────────────────────────────────────────────

function ReportKPIWidget({ label, value, color, Icon, trend }) {
  return (
    <div className="ri-kpi-card" style={{ "--accent": color }}>
      <div className="ri-kpi-icon">
        <Icon />
      </div>
      <div className="ri-kpi-body">
        <span className="ri-kpi-value">{value}</span>
        <span className="ri-kpi-label">{label}</span>
      </div>
      {trend && <span className="ri-kpi-trend">{trend}</span>}
    </div>
  );
}

// ─── TABS ─────────────────────────────────────────────────────────────────────

function ViewTabs({ active, onChange }) {
  const tabs = [
    { id: "create", label: "Create Report" },
    { id: "my", label: "My Reports" },
    { id: "tracker", label: "Resolution Tracker" },
  ];
  return (
    <div className="ri-tabs">
      {tabs.map((t) => (
        <button
          key={t.id}
          className={`ri-tab${active === t.id ? " active" : ""}`}
          onClick={() => onChange(t.id)}
        >
          {t.label}
        </button>
      ))}
    </div>
  );
}

// ─── WIZARD ──────────────────────────────────────────────────────────────────

function ReportWizard({ onSuccess }) {
  const [step, setStep] = useState(0);
  const [form, setForm] = useState({
    category: "",
    issueType: "",
    description: "",
    attachments: [],
    linkInput: "",
    priority: "medium",
  });
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const fileRef = useRef();

  const steps = [
    "Category",
    "Issue Type",
    "Description",
    "Attachments",
    "Priority",
    "Review",
  ];

  const canNext = () => {
    if (step === 0) return !!form.category;
    if (step === 1) return !!form.issueType;
    if (step === 2) return form.description.trim().length > 20;
    return true;
  };

  const handleSubmit = () => {
    setSubmitting(true);
    setTimeout(() => {
      setSubmitting(false);
      setSubmitted(true);
      if (onSuccess) onSuccess();
    }, 1600);
  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    setForm((f) => ({ ...f, attachments: [...f.attachments, ...files] }));
  };

  const removeFile = (idx) => {
    setForm((f) => ({
      ...f,
      attachments: f.attachments.filter((_, i) => i !== idx),
    }));
  };

  const resetWizard = () => {
    setSubmitted(false);
    setStep(0);
    setForm({
      category: "",
      issueType: "",
      description: "",
      attachments: [],
      linkInput: "",
      priority: "medium",
    });
  };

  if (submitted) {
    return (
      <div className="ri-wizard-success">
        <div className="ri-success-icon">
          <Icons.Check />
        </div>
        <h3>Report Submitted Successfully</h3>
        <p>
          Your report has been assigned a unique ID. Our support team will
          review it shortly and respond within 4 hours.
        </p>
        <button className="ri-btn-primary" onClick={resetWizard}>
          Submit Another Report
        </button>
      </div>
    );
  }

  return (
    <div className="ri-wizard">
      {/* Progress */}
      <div className="ri-wizard-progress">
        {steps.map((s, i) => (
          <React.Fragment key={s}>
            <div
              className={`ri-progress-step ${i < step ? "done" : i === step ? "active" : ""}`}
            >
              <div className="ri-progress-dot">
                {i < step ? <Icons.Check /> : <span>{i + 1}</span>}
              </div>
              <span className="ri-progress-label">{s}</span>
            </div>
            {i < steps.length - 1 && (
              <div className={`ri-progress-line ${i < step ? "done" : ""}`} />
            )}
          </React.Fragment>
        ))}
      </div>

      {/* Step Content */}
      <div className="ri-wizard-body">
        {step === 0 && (
          <div className="ri-step-panel">
            <h3 className="ri-step-title">What is the issue related to?</h3>
            <p className="ri-step-sub">
              Select the category that best describes your issue
            </p>
            <div className="ri-category-grid">
              {CATEGORIES.map(({ id, label, Icon }) => (
                <button
                  key={id}
                  className={`ri-category-card ${form.category === id ? "selected" : ""}`}
                  onClick={() =>
                    setForm((f) => ({ ...f, category: id, issueType: "" }))
                  }
                >
                  <span className="ri-cat-icon">
                    <Icon />
                  </span>
                  <span>{label}</span>
                  {form.category === id && (
                    <span className="ri-cat-check">
                      <Icons.Check />
                    </span>
                  )}
                </button>
              ))}
            </div>
          </div>
        )}

        {step === 1 && (
          <div className="ri-step-panel">
            <h3 className="ri-step-title">Specify the Issue Type</h3>
            <p className="ri-step-sub">
              Choose the most accurate description for your issue
            </p>
            <div className="ri-issue-list">
              {(ISSUE_TYPES[form.category] || []).map((type) => (
                <label
                  key={type}
                  className={`ri-issue-option ${form.issueType === type ? "selected" : ""}`}
                >
                  <input
                    type="radio"
                    name="issueType"
                    value={type}
                    checked={form.issueType === type}
                    onChange={() => setForm((f) => ({ ...f, issueType: type }))}
                  />
                  <span className="ri-radio-dot" />
                  <span>{type}</span>
                </label>
              ))}
            </div>
          </div>
        )}

        {step === 2 && (
          <div className="ri-step-panel">
            <h3 className="ri-step-title">Describe Your Issue</h3>
            <p className="ri-step-sub">
              Provide as much detail as possible for faster resolution
            </p>
            <textarea
              className="ri-textarea"
              placeholder="Describe what happened, when it occurred, and any relevant details. Be specific to help us resolve your issue faster."
              value={form.description}
              onChange={(e) =>
                setForm((f) => ({ ...f, description: e.target.value }))
              }
              rows={8}
            />
            <div className="ri-char-count">
              {form.description.length} characters
              {form.description.length < 20 && form.description.length > 0
                ? " — minimum 20 required"
                : ""}
            </div>
          </div>
        )}

        {step === 3 && (
          <div className="ri-step-panel">
            <h3 className="ri-step-title">Add Supporting Evidence</h3>
            <p className="ri-step-sub">
              Attachments help us resolve your issue faster (optional)
            </p>
            <div
              className="ri-upload-zone"
              onClick={() => fileRef.current.click()}
            >
              <span className="ri-upload-icon">
                <Icons.Upload />
              </span>
              <span>Click to upload files or screenshots</span>
              <small>PNG, JPG, PDF up to 10MB each</small>
              <input
                ref={fileRef}
                type="file"
                multiple
                accept=".png,.jpg,.jpeg,.pdf"
                style={{ display: "none" }}
                onChange={handleFileChange}
              />
            </div>
            {form.attachments.length > 0 && (
              <div className="ri-file-list">
                {form.attachments.map((f, i) => (
                  <div key={i} className="ri-file-item">
                    <span className="ri-file-icon">
                      <Icons.Attach />
                    </span>
                    <span>{f.name}</span>
                    <button
                      className="ri-file-remove"
                      onClick={() => removeFile(i)}
                    >
                      <Icons.Close />
                    </button>
                  </div>
                ))}
              </div>
            )}
            <div className="ri-link-input-wrap">
              <span className="ri-link-icon">
                <Icons.Link />
              </span>
              <input
                type="url"
                className="ri-link-input"
                placeholder="Or paste a relevant URL / screenshot link"
                value={form.linkInput}
                onChange={(e) =>
                  setForm((f) => ({ ...f, linkInput: e.target.value }))
                }
              />
            </div>
          </div>
        )}

        {step === 4 && (
          <div className="ri-step-panel">
            <h3 className="ri-step-title">Set Priority Level</h3>
            <p className="ri-step-sub">
              Select the urgency that reflects the impact on your learning
            </p>
            <div className="ri-priority-grid">
              {PRIORITIES.map((p) => (
                <button
                  key={p.id}
                  className={`ri-priority-card ${form.priority === p.id ? "selected" : ""} ${p.id === "urgent" ? "urgent-pulse" : ""}`}
                  style={{ "--p-color": p.color }}
                  onClick={() => setForm((f) => ({ ...f, priority: p.id }))}
                >
                  <span className="ri-priority-dot" />
                  <div>
                    <strong>{p.label}</strong>
                    <span>{p.desc}</span>
                  </div>
                  {form.priority === p.id && (
                    <span className="ri-cat-check">
                      <Icons.Check />
                    </span>
                  )}
                </button>
              ))}
            </div>
          </div>
        )}

        {step === 5 && (
          <div className="ri-step-panel">
            <h3 className="ri-step-title">Review and Submit</h3>
            <p className="ri-step-sub">
              Confirm the details below before submitting your report
            </p>
            <div className="ri-review-card">
              <div className="ri-review-row">
                <span>Category</span>
                <strong>
                  {CATEGORIES.find((c) => c.id === form.category)?.label}
                </strong>
              </div>
              <div className="ri-review-row">
                <span>Issue Type</span>
                <strong>{form.issueType}</strong>
              </div>
              <div className="ri-review-row">
                <span>Priority</span>
                <strong
                  style={{
                    color: PRIORITIES.find((p) => p.id === form.priority)
                      ?.color,
                  }}
                >
                  {PRIORITIES.find((p) => p.id === form.priority)?.label}
                </strong>
              </div>
              <div className="ri-review-row">
                <span>Attachments</span>
                <strong>
                  {form.attachments.length} file(s)
                  {form.linkInput ? " + 1 link" : ""}
                </strong>
              </div>
              <div className="ri-review-desc">
                <span>Description</span>
                <p>{form.description}</p>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Navigation */}
      <div className="ri-wizard-nav">
        {step > 0 && (
          <button
            className="ri-btn-ghost"
            onClick={() => setStep((s) => s - 1)}
          >
            <Icons.ChevronLeft /> Back
          </button>
        )}
        <div style={{ flex: 1 }} />
        {step < steps.length - 1 ? (
          <button
            className="ri-btn-primary"
            disabled={!canNext()}
            onClick={() => setStep((s) => s + 1)}
          >
            Next <Icons.ChevronRight />
          </button>
        ) : (
          <button
            className="ri-btn-primary ri-btn-submit"
            disabled={submitting}
            onClick={handleSubmit}
          >
            {submitting ? (
              <span className="ri-spinner" />
            ) : (
              <>
                <Icons.Send />
                &nbsp;Submit Report
              </>
            )}
          </button>
        )}
      </div>
    </div>
  );
}

// ─── STATUS BADGE ─────────────────────────────────────────────────────────────

function StatusBadge({ status }) {
  const map = {
    open: { label: "Open", cls: "badge-open" },
    in_progress: { label: "In Progress", cls: "badge-progress" },
    resolved: { label: "Resolved", cls: "badge-resolved" },
    rejected: { label: "Rejected", cls: "badge-rejected" },
  };
  const s = map[status] || map.open;
  return <span className={`ri-badge ${s.cls}`}>{s.label}</span>;
}

function PriorityBadge({ priority }) {
  const map = {
    low: "badge-low",
    medium: "badge-medium",
    high: "badge-high",
    urgent: "badge-urgent",
  };
  const label = priority
    ? priority.charAt(0).toUpperCase() + priority.slice(1)
    : "";
  return <span className={`ri-badge ${map[priority] || ""}`}>{label}</span>;
}

// ─── REPORT CARD ─────────────────────────────────────────────────────────────

function ReportCard({ report, onView }) {
  const catData = CATEGORIES.find((c) => c.id === report.category);
  const Icon = catData?.Icon || Icons.Other;
  const date = new Date(report.createdAt).toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });

  return (
    <div className="ri-report-card">
      <div className="ri-rc-header">
        <div className="ri-rc-meta">
          <span className="ri-rc-id">{report.id}</span>
          <StatusBadge status={report.status} />
          <PriorityBadge priority={report.priority} />
        </div>
        <span className="ri-rc-date">{date}</span>
      </div>
      <div className="ri-rc-body">
        <div className="ri-rc-cat">
          <span className="ri-rc-cat-icon">
            <Icon />
          </span>
          <span>{report.categoryLabel}</span>
          <span className="ri-rc-sep">·</span>
          <span>{report.issueType}</span>
        </div>
        <h4 className="ri-rc-subject">{report.subject}</h4>
      </div>
      <div className="ri-rc-footer">
        {report.assignedTo && (
          <span className="ri-rc-assigned">
            <Icons.Agent /> {report.assignedTo}
          </span>
        )}
        <div className="ri-rc-actions">
          <button className="ri-action-btn" onClick={() => onView(report)}>
            <Icons.Eye /> View Details
          </button>
          <button className="ri-action-btn">
            <Icons.Comment /> Comment
          </button>
          {report.status === "resolved" && (
            <button className="ri-action-btn ri-action-reopen">
              <Icons.Reopen /> Reopen
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

// ─── TIMELINE ─────────────────────────────────────────────────────────────────

function ReportTimeline({ timeline }) {
  return (
    <div className="ri-timeline">
      {timeline.map((item, i) => (
        <div key={i} className={`ri-tl-item ${item.done ? "done" : "pending"}`}>
          <div className="ri-tl-left">
            <div className="ri-tl-icon">
              {item.done ? <Icons.Check /> : <span>{i + 1}</span>}
            </div>
            {i < timeline.length - 1 && <div className="ri-tl-line" />}
          </div>
          <div className="ri-tl-content">
            <strong>{item.stage}</strong>
            {item.time && <span className="ri-tl-time">{item.time}</span>}
            {item.agent && (
              <span className="ri-tl-agent">
                <Icons.Agent /> {item.agent}
              </span>
            )}
            {item.note && <p className="ri-tl-note">{item.note}</p>}
          </div>
        </div>
      ))}
    </div>
  );
}

// ─── DETAIL PANEL ─────────────────────────────────────────────────────────────

function ReportDetailPanel({ report, onClose }) {
  const [reply, setReply] = useState("");

  if (!report) return null;

  return (
    <>
      <div className="ri-overlay" onClick={onClose} />
      <div className="ri-drawer">
        <div className="ri-drawer-header">
          <div className="ri-drawer-header-info">
            <div className="ri-drawer-id">{report.id}</div>
            <h3 className="ri-drawer-title">{report.subject}</h3>
            <div className="ri-drawer-meta">
              <StatusBadge status={report.status} />
              <PriorityBadge priority={report.priority} />
              <span className="ri-drawer-cat">{report.categoryLabel}</span>
            </div>
          </div>
          <button className="ri-drawer-close" onClick={onClose}>
            <Icons.Close />
          </button>
        </div>

        <div className="ri-drawer-body">
          <section className="ri-drawer-section">
            <h5>Description</h5>
            <p>{report.description}</p>
          </section>

          <section className="ri-drawer-section">
            <h5>Resolution Timeline</h5>
            <ReportTimeline timeline={report.timeline} />
          </section>

          <section className="ri-drawer-section">
            <h5>Conversation Thread</h5>
            <div className="ri-thread">
              {report.thread.map((msg) => (
                <div
                  key={msg.id}
                  className={`ri-thread-msg ${msg.role === "student" ? "self" : "support"}`}
                >
                  <div className="ri-thread-avatar">{msg.sender.charAt(0)}</div>
                  <div className="ri-thread-bubble">
                    <div className="ri-thread-info">
                      <strong>{msg.sender}</strong>
                      <span>{msg.time}</span>
                    </div>
                    <p>{msg.message}</p>
                  </div>
                </div>
              ))}
            </div>
          </section>
        </div>

        <div className="ri-drawer-footer">
          <div className="ri-reply-box">
            <textarea
              className="ri-reply-input"
              placeholder="Add a reply or provide additional information..."
              value={reply}
              onChange={(e) => setReply(e.target.value)}
              rows={3}
            />
            <div className="ri-reply-actions">
              <button className="ri-action-btn">
                <Icons.Attach /> Attach
              </button>
              <button className="ri-btn-primary" disabled={!reply.trim()}>
                <Icons.Send /> Send Reply
              </button>
            </div>
          </div>
          {report.status !== "resolved" && (
            <button className="ri-btn-ghost ri-btn-close-report">
              <Icons.Check /> Mark as Resolved
            </button>
          )}
        </div>
      </div>
    </>
  );
}

// ─── MY REPORTS DASHBOARD ────────────────────────────────────────────────────

function MyReportsDashboard({ onViewReport }) {
  const [filter, setFilter] = useState("all");
  const filters = ["all", "open", "in_progress", "resolved"];
  const filtered =
    filter === "all"
      ? MOCK_REPORTS
      : MOCK_REPORTS.filter((r) => r.status === filter);

  return (
    <div className="ri-my-reports">
      <div className="ri-filter-bar">
        {filters.map((f) => (
          <button
            key={f}
            className={`ri-filter-btn ${filter === f ? "active" : ""}`}
            onClick={() => setFilter(f)}
          >
            {f === "all"
              ? "All Reports"
              : f === "in_progress"
                ? "In Progress"
                : f.charAt(0).toUpperCase() + f.slice(1)}
          </button>
        ))}
      </div>
      <div className="ri-reports-list">
        {filtered.length === 0 ? (
          <div className="ri-empty">No reports found for this filter.</div>
        ) : (
          filtered.map((r) => (
            <ReportCard key={r.id} report={r} onView={onViewReport} />
          ))
        )}
      </div>
    </div>
  );
}

// ─── TRACKER VIEW ─────────────────────────────────────────────────────────────

function ResolutionTracker({ onViewReport }) {
  return (
    <div className="ri-tracker">
      <p className="ri-tracker-intro">
        Track the progress of each report through our resolution pipeline in
        real time.
      </p>
      {MOCK_REPORTS.map((report) => (
        <div key={report.id} className="ri-tracker-card">
          <div className="ri-tracker-header">
            <div className="ri-tracker-header-left">
              <span className="ri-rc-id">{report.id}</span>
              <StatusBadge status={report.status} />
            </div>
            <button
              className="ri-action-btn"
              onClick={() => onViewReport(report)}
            >
              <Icons.Eye /> Full Details
            </button>
          </div>
          <h4 className="ri-tracker-subject">{report.subject}</h4>
          <ReportTimeline timeline={report.timeline} />
        </div>
      ))}
    </div>
  );
}

// ─── MAIN PAGE ────────────────────────────────────────────────────────────────

export default function Report() {
  const [activeTab, setActiveTab] = useState("create");
  const [selectedReport, setSelectedReport] = useState(null);

  const kpis = [
    {
      label: "Open Reports",
      value: 1,
      color: "#3b82f6",
      Icon: Icons.Open,
      trend: "+2 this week",
    },
    {
      label: "In Progress",
      value: 1,
      color: "#f59e0b",
      Icon: Icons.InProgress,
      trend: "Active",
    },
    {
      label: "Resolved",
      value: 1,
      color: "#10b981",
      Icon: Icons.Resolved,
      trend: "3 this month",
    },
    {
      label: "Avg Response",
      value: "4h",
      color: "#8b5cf6",
      Icon: Icons.Clock,
      trend: "Target: 6h",
    },
  ];

  return (
    <MyStudentLayout>
      <div className="ri-page">
        {/* Header */}
        <div className="ri-header">
          <div className="ri-header-text">
            <h1>Report Issues</h1>
            <p>
              Submit and track issues related to mentors, courses, payments, or
              platform
            </p>
          </div>
          <button
            className="ri-btn-primary"
            onClick={() => setActiveTab("create")}
          >
            <Icons.Flag />
            &nbsp;New Report
          </button>
        </div>

        {/* KPI Cards */}
        <div className="ri-kpi-grid">
          {kpis.map((k) => (
            <ReportKPIWidget key={k.label} {...k} />
          ))}
        </div>

        {/* Tabs */}
        <ViewTabs active={activeTab} onChange={setActiveTab} />

        {/* Tab Content */}
        <div className="ri-tab-content">
          {activeTab === "create" && (
            <ReportWizard
              onSuccess={() => setTimeout(() => setActiveTab("my"), 2000)}
            />
          )}
          {activeTab === "my" && (
            <MyReportsDashboard onViewReport={setSelectedReport} />
          )}
          {activeTab === "tracker" && (
            <ResolutionTracker onViewReport={setSelectedReport} />
          )}
        </div>

        {/* Detail Panel */}
        {selectedReport && (
          <ReportDetailPanel
            report={selectedReport}
            onClose={() => setSelectedReport(null)}
          />
        )}
      </div>
    </MyStudentLayout>
  );
}
